import { Grid, Typography } from '@mui/material';
import { Surface } from '../../../components/primitives';
import ChartSection from '../shared/ChartSection';
import { fmtMoney, fmtPct } from '../shared/formatters';

export default function PartyComparison({ data }) {
    if (!data || Object.keys(data).length === 0) return null;

    const parties = Object.entries(data).filter(([p]) => p === 'Democratic' || p === 'Republican');
    if (parties.length === 0) return null;

    return (
        <ChartSection id="party" title="Democrats vs Republicans: Who trades better?" takeaway={(() => {
            const dem = data.Democratic;
            const rep = data.Republican;
            if (!dem || !rep) return null;
            const winner = dem.avg_alpha > rep.avg_alpha ? 'Democrats' : 'Republicans';
            const diff = Math.abs(dem.avg_alpha - rep.avg_alpha).toFixed(1);
            return `${winner} edge out by ${diff} percentage points in average alpha — but both parties have standout traders and underperformers, so party affiliation alone isn't a strong predictor.`;
        })()}>
            <Grid container spacing={2}>
                {parties.map(([party, stats]) => (
                    <Grid item xs={12} md={6} key={party}>
                        <Surface variant="subtle" padding={2.5}>
                            <Typography variant="body1" sx={{ color: party === 'Democratic' ? '#3b82f6' : '#ef4444', fontWeight: 700, mb: 1.5 }}>
                                {party === 'Democratic' ? 'Democrats' : 'Republicans'}
                            </Typography>
                            <Grid container spacing={1.5}>
                                {[
                                    { label: 'Avg Alpha', value: fmtPct(stats.avg_alpha), color: stats.avg_alpha >= 0 ? 'success.main' : 'error.main' },
                                    { label: 'Beat Market', value: stats.pct_positive + '%', color: 'text.primary' },
                                    { label: 'Members', value: stats.members, color: 'text.primary' },
                                    { label: 'Est. Profit', value: fmtMoney(stats.total_estimated_profit), color: 'text.primary' },
                                ].map((s, i) => (
                                    <Grid item xs={6} key={i}>
                                        <Typography variant="overline" sx={{ color: 'text.muted', display: 'block', lineHeight: 1 }}>{s.label}</Typography>
                                        <Typography sx={{ fontSize: '1.1rem', fontWeight: 700, fontFamily: t => t.typography.fontFamilyMono, color: s.color }}>{s.value}</Typography>
                                    </Grid>
                                ))}
                            </Grid>
                        </Surface>
                    </Grid>
                ))}
            </Grid>
        </ChartSection>
    );
}
